import Swal from "sweetalert2";

const deleteConfirm = async (url, fetchData) => {
  const token = localStorage.getItem("token"); // ✅ جلب التوكن من التخزين المحلي

  if (!token) {
    Swal.fire("Error!", "Not authorized, no token found.", "error");
    return;
  }

  return Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`, // ✅ تمرير التوكن هنا
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();

        if (res.ok) {
          Swal.fire("Deleted!", data.message || "Item deleted successfully", "success");
          if (fetchData) fetchData(); // 🔄 تحديث الجدول بعد الحذف
        } else {
          Swal.fire("Error!", data.message || "Something went wrong", "error");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete item", "error");
      }
    }
  });
};

export default deleteConfirm;
